import React, { useState, useEffect } from "react";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import "react-toastify/dist/ReactToastify.css";
import "react-widgets/styles.css";
import DropdownList from "react-widgets/DropdownList";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { fetchFlowTypeMeta, setFlowTypeMeta } from "../../redux/actions/flowActions";
import { addFlowToStepRemote, addFlowToStepLocal, addIngredient, addIngredientLocal } from "../../redux/actions/analysisActions";
import ComponentLoading from "../../commonComponents/ComponentLoading";

const AddStep = ({ setAddMenu, step, is_substep }) => {
  const [addFilter, setAddFilter] = useState("");
  const [value, setValue] = useState("Choisir un type...");

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchFlowTypeMeta_rd = (item) => dispatch(fetchFlowTypeMeta(item));
  const setFlowTypeMeta_rd = (item) => dispatch(setFlowTypeMeta(item));
  const addFlowToStepRemote_rd = (item) => dispatch(addFlowToStepRemote(item));
  const addFlowToStepLocal_rd = (item) => dispatch(addFlowToStepLocal(item));
  const addIngredient_rd = (item) => dispatch(addIngredient(item));
  const addIngredientLocal_rd = (item) => dispatch(addIngredientLocal(item));
  // const { undo, redo } = ActionCreators;
  const [loading, setLoading] = useState(false);

  let [flow_categories, set_flow_categories] = useState([
    { id: 0, name: "K_Raw_Materials" },
    { id: 1, name: "K_Packaging" },
    { id: 2, name: "K_Transports" },
    { id: 3, name: "K_Wastes" },
    { id: 4, name: "K_Energies" },
    { id: 5, name: "K_Cooking" },
    { id: 6, name: "K_Food_Given" },
  ]);

  useEffect(() => {
    console.log("ADD STEP EFFECT ");
    setFlowTypeMeta_rd();
    if (step === 2) {
      set_flow_categories([{ id: 0, name: "K_Raw_Materials" }, { id: 5, name: "K_Cooking" }]);
      fetchFlowTypeMeta_rd("K_Raw_Materials");
      setValue("K_Raw_Materials");
    } else if (is_substep) {
      set_flow_categories([{ id: 3, name: "K_Wastes" }, { id: 6, name: "K_Food_Given" },]);
      fetchFlowTypeMeta_rd("K_Wastes");
      setValue("K_Wastes");
    } else {
      fetchFlowTypeMeta_rd(null);
      set_flow_categories([
        { id: 1, name: "K_Packaging" },
        { id: 2, name: "K_Transports" },
        { id: 3, name: "K_Wastes" },
        { id: 4, name: "K_Energies" },
        { id: 6, name: "K_Food_Given" }
      ]);
    }
  }, []);

  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const analysis_data = useSelector((state) => (state.analysis.analysis_data ? state.analysis.analysis_data : null));
  // reset meta
  const flow_type_meta = useSelector((state) => (state.flow.flow_type_meta ? state.flow.flow_type_meta : null));

  const handleAddFlowStep = async (current) => {
    let item = {
      flow_meta: current,
      step_index: Math.abs(step - 6),
      analysis_id: analysis_id,
      k_type: value
      // ingredients_size: Object.values(analysis_data.ingredients).length,
    };
    if (item.step_index === 4) {
      item.type = "add_ingredient";
      // add ingredients
      // console.log("toto", item);
      await addIngredientLocal_rd(item);
      // item.flow_uid = flow_usid; // ??
      // console.log("item", item)
      await addIngredient_rd(item);
    } else {
      item.type = "add_flow";
      const new_item = await addFlowToStepLocal_rd(item);
      await addFlowToStepRemote_rd(new_item);
    }
  };

  return (
    <div>
      <div className="w-[370px] h-full absolute">
        <div className="w-[370px] bg-white shadow border-[1px] ml-[560px] mb-[50px] border-[#BEC4CA] relative z-20 rounded-xl">
          <div className="h-[50px] w-full flex items-center justify-between">
            <p className="font-Poppins-SemiBold text-sm ml-[10px]">Type de procédé</p>
            <button
              onClick={() => {
                setAddMenu(0);
              }}
            >
              <Cross height={20} />
            </button>
          </div>
          <div className="w-full flex justify-center">
            <div className=" w-[340px] border-b-[1px] border-[#BEC4CA] p-[5px]">
              <DropdownList
                className="h-[40px] w-[340px] bg-[#F3F5F7]"
                data={flow_categories}
                dataKey="id"
                textField="name"
                value={value}
                onChange={async (value) => {
                  setLoading(true);
                  setValue(value.name);
                  await fetchFlowTypeMeta_rd(value.name);
                  setLoading(false);
                }}
              />
            </div>
          </div>

          <input
            placeholder="Rechercher un indicateur d'impact"
            className="p-[20px] mt-3 w-[300px] h-[30px] rounded-xl text-gray-500 bg-[#BEC4CA]/20 ml-[10px]"
            onChange={(event) => {
              let result = event.target.value;
              result = result.toLocaleLowerCase();
              setAddFilter(result);
            }}
          />
          <div className="font-Poppins-Regular w-[370px] text-xs overflow-y-auto overflow-hidden h-[240px] mt-[20px]">
            {flow_type_meta ? (
              <>
                {flow_type_meta &&
                  flow_type_meta.map((current) => {
                    if (current.name && current.name.toLocaleLowerCase().includes(addFilter)) {
                      return (
                        <button
                          className="h-max w-[350px] text-left mx-[10px] mr-[15px] hover:bg-[#BEC4CA] nth-child-2n:bg-[#F3F5F7] my-[3px]"
                          key={`${current.id}`}
                          onClick={async () => {
                            console.log("ONCLICKRT", current);
                            setLoading(true);
                            await handleAddFlowStep(current);
                            setLoading(false);
                            // close addmenu :
                            setAddMenu(0);
                          }}
                        >
                          {current.name}
                        </button>
                      );
                    }
                  })}
              </>
            ) : (
              <>
                {value === "Choisir un type..." ? (
                  <></>
                ) : (
                  <>
                    <ComponentLoading height={35} style={"mt-[40px] flex items-center justify-center"} />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStep;
